import Card from '@perpay-web/components/base/Card/Card';
import metalCard from '@perpay-web/fintech/assets/images/perpayMetalCard.png';
import plasticCard from '@perpay-web/fintech/assets/images/perpayPlasticCardFrontNewLogo.png';
import { cardFees } from '@perpay-web/fintech/constants/cardFeesConstants';
import {
    METAL_MATERIAL,
    PLASTIC_MATERIAL,
} from '@perpay-web/fintech/utils/cardAccountApplicationMetalUtils';
import { getClassName } from '@perpay-web/utils/domUtils';
import { formatCurrency } from '@perpay-web/utils/stringUtils';

import styles from './CardMaterialSelection.scss';

const metalCardFeeString = formatCurrency(cardFees.METAL_CARD_FEE, true, false);

const plasticCardList = [
    '5 grams of flexible plastic',
    '2% rewards with every card payment',
];

const metalCardList = [
    '18 grams of durable recycled steel',
    '2% rewards with every card payment',
    'Tap to pay',
];

const CardMaterialSelection = ({
    value,
    onChange,
    onClickHeavyMetal,
    onClickLightPlastic,
}) => {
    const isPlasticMaterial = value === PLASTIC_MATERIAL;
    const list = isPlasticMaterial ? plasticCardList : metalCardList;

    const handlePlasticMaterialButtonClick = () => {
        onChange(PLASTIC_MATERIAL);
        onClickLightPlastic();
    };

    const handleMetalMaterialButtonClick = () => {
        onChange(METAL_MATERIAL);
        onClickHeavyMetal();
    };
    return (
        <div className={styles.container}>
            <div className={styles.header}>Choose your style</div>
            <div className={styles.switcher}>
                <button
                    type='button'
                    className={getClassName(
                        styles.button,
                        isPlasticMaterial && styles.button__disabled,
                    )}
                    onClick={handleMetalMaterialButtonClick}
                >
                    Metal
                </button>
                <button
                    type='button'
                    className={getClassName(
                        styles.button,
                        !isPlasticMaterial && styles.button__disabled,
                    )}
                    onClick={handlePlasticMaterialButtonClick}
                >
                    Plastic
                </button>
            </div>

            <Card className={styles.card}>
                <div className={styles['img-container']}>
                    {!isPlasticMaterial && (
                        <div className={styles.pill}>
                            Metal {metalCardFeeString}
                        </div>
                    )}
                    <img
                        className={getClassName(
                            styles.img,
                            styles.img__plastic,
                            !isPlasticMaterial && styles['img--hidden'],
                        )}
                        src={plasticCard}
                        alt='plastic_card'
                    />
                    <img
                        className={getClassName(
                            styles.img,
                            styles.img__metal,
                            isPlasticMaterial && styles['img--hidden'],
                        )}
                        src={metalCard}
                        alt='metal_card'
                    />
                </div>
                <div className={styles.list__wrapper}>
                    <div className={styles.list__title}>
                        {isPlasticMaterial
                            ? 'The Light Plastic Credit Card'
                            : 'The Heavy Metal Credit Card'}
                    </div>
                    <div className={styles.list}>
                        {list.map((item) => (
                            <div key={item} className={styles.list__item}>
                                <div className={styles.list__icon} />
                                {item}
                            </div>
                        ))}
                    </div>
                </div>
            </Card>
        </div>
    );
};

export default CardMaterialSelection;
